import React from 'react';
import PropTypes, { bool } from 'prop-types';

import {
    Button,
    Modal,
    ModalBody,
    ModalHeader,

} from 'reactstrap';

const PopupWindow = ({ btnClass, key, hideButton, title, children, launchButtonText, buttonStyle, openWindow,handlePopup,btnSize='sm',color='primary' }) => {

    const [open, setOpen] = React.useState(openWindow);
    const toggle = () => {
        handlePopup(!open);
        setOpen(!open)
    }
    React.useEffect(() => {
        setOpen(openWindow);
    }, [openWindow])
    
    return (
        <>
            {(!hideButton) && <Button color={color} size={btnSize} style={buttonStyle} className={`border-0 ${btnClass}`} onClick={toggle}>{launchButtonText}</Button>}
            <Modal className={(btnClass)?`model-${btnClass}`:''} isOpen={open} key={key}>
                <ModalHeader style={{padding:'8px 18px'}}toggle={toggle}>{title}</ModalHeader>
                <ModalBody>
                    {children}
                </ModalBody>
            </Modal>
        </>
    );
}

PopupWindow.propTypes = {
    open: PropTypes.bool,
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    launchButtonText: PropTypes.string,
    buttonStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    openWindow: bool,
    handlePopup:PropTypes.func,
    btnSize:PropTypes.string,
    key:PropTypes.string,
    hideButton:PropTypes.bool,
    btnClass:PropTypes.string,
};

PopupWindow.defaultProps = {
    key: 'popupWindow-1',
    hideButton:false,
    btnClass:''
  
  };

export default PopupWindow;